var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXtractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.279,
    height: 13.427,
    viewBox: "0 0 48.279 13.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_220077",
    "data-name": "Group 220077",
    transform: "translate(-34.524 -12.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220061",
    "data-name": "Group 220061",
    transform: "translate(3.4 -8.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-twitterx-500",
    d: "M0,0,4.974,7.251.105,12.891H1.184L5.451,7.946l3.393,4.946h4.076l-5.2-7.575L12.308,0H11.233L7.245,4.62,4.076,0ZM1.288.678,8.843,12.891l2.788-.678H9.2Z",
    transform: "translate(44.518 34.723) rotate(180)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69351",
    "data-name": "Path 69351",
    d: "M10442.87,3829.748l3.669-4.243,2.621,1.645-4.189,4.762Z",
    transform: "translate(-10406.413 -3798.203)",
    fill: "#0e4de0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69352",
    "data-name": "Path 69352",
    d: "M-14.324-3.64v4.3a.825.825,0,0,0,.2.627,1.016,1.016,0,0,0,.7.19h.986V2.812H-13.7A2.444,2.444,0,0,1-15.367,2.3,2.09,2.09,0,0,1-15.944.657v-4.3h-.916V-4.95h.916V-6.88h1.62v1.93h1.888v1.31Zm4.973-.183a2.522,2.522,0,0,1,.937-.923,2.771,2.771,0,0,1,1.388-.331v1.662h-.409a1.956,1.956,0,0,0-1.43.479,2.29,2.29,0,0,0-.486,1.662V2.812h-1.606V-4.95h1.606ZM-6.083-1.1A4.3,4.3,0,0,1-5.6-3.175a3.562,3.562,0,0,1,1.324-1.4,3.548,3.548,0,0,1,1.852-.5,3.388,3.388,0,0,1,1.6.359A3.245,3.245,0,0,1,.27-3.823V-4.95H1.89V2.812H.27V1.657a3.189,3.189,0,0,1-1.113.916,3.43,3.43,0,0,1-1.606.366A3.413,3.413,0,0,1-4.28,2.425,3.647,3.647,0,0,1-5.6.988,4.42,4.42,0,0,1-6.083-1.1ZM.27-1.076A2.811,2.811,0,0,0-.061-2.471a2.324,2.324,0,0,0-.866-.9,2.267,2.267,0,0,0-1.155-.31,2.307,2.307,0,0,0-1.155.3,2.284,2.284,0,0,0-.866.887A2.771,2.771,0,0,0-4.435-1.1,2.891,2.891,0,0,0-4.1.3a2.336,2.336,0,0,0,.873.923,2.24,2.24,0,0,0,1.148.317,2.267,2.267,0,0,0,1.155-.31A2.312,2.312,0,0,0-.061.326,2.851,2.851,0,0,0,.27-1.076Zm3.2,0a4.4,4.4,0,0,1,.486-2.106A3.457,3.457,0,0,1,5.3-4.584a3.892,3.892,0,0,1,1.972-.493A3.87,3.87,0,0,1,9.6-4.408,3.294,3.294,0,0,1,10.849-2.5H9.117a1.832,1.832,0,0,0-.676-.9,2,2,0,0,0-1.169-.324,1.944,1.944,0,0,0-1.571.7,2.95,2.95,0,0,0-.585,1.951A2.979,2.979,0,0,0,5.7.882a1.936,1.936,0,0,0,1.571.7A1.782,1.782,0,0,0,9.117.361h1.733A3.469,3.469,0,0,1,9.581,2.241a3.742,3.742,0,0,1-2.31.7,3.848,3.848,0,0,1-1.972-.5A3.5,3.5,0,0,1,3.954,1.03,4.4,4.4,0,0,1,3.468-1.076ZM14.329-3.64v4.3a.825.825,0,0,0,.2.627,1.016,1.016,0,0,0,.7.19h.986V2.812H14.949A2.444,2.444,0,0,1,13.286,2.3,2.09,2.09,0,0,1,12.709.657v-4.3h-.916V-4.95h.916V-6.88h1.62v1.93h1.888v1.31Z",
    transform: "translate(63.186 31.984)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtractIcon);
export default __webpack_public_path__ + "static/media/XtractIcon.b069e5c404969d614add082da9f05678.svg";
export { ForwardRef as ReactComponent };